'use client'

import { GoogleAdClient } from '@/components/v3/atoms/google-ad-client/google-ad-client'
import { CATEGORY_PAGE_ADS } from '@/constants/ads-slots'
import { BannerCard, SpecialCard } from '@/types/api/ui-placement'
import { getAdObjectByKey } from '@/utils/getAdObjectByKey'
import { format } from 'date-fns'
import { usePathname } from 'next/navigation'
import { BannerCardNavigationSlider } from '../../../v2/molecules/custom-slider/banner-card-navigation-slider/banner-card-navigation-slider'
import { SpecialCard as SpecialCardComponent } from '../../atoms/special-card/special-card'
import s from './special-cards.module.css'

type Props = {
  specialCard: SpecialCard
  bannerCards: BannerCard[]
  headingLevel?: 'h2' | 'h3' | 'h4'
}

export const SpecialCards = ({
  specialCard,
  bannerCards,
  headingLevel,
}: Props) => {
  const pathname = usePathname()
  const articleCategoryName =
    specialCard.article?.article_subcategories?.name ||
    specialCard.article?.article_categories?.name ||
    ''
  const adObject = getAdObjectByKey(pathname, CATEGORY_PAGE_ADS)

  return (
    <div className={s.wrapper}>
      <div className={s.container}>
        <SpecialCardComponent
          category={articleCategoryName}
          date={format(specialCard?.article.published_date!, 'dd.MM.yyyy')}
          header={specialCard.article.title!}
          imageUrl={specialCard.article.hero_image_ref.url!}
          description={
            specialCard.article.introduction_copy ||
            specialCard.article.description
          }
          path={specialCard.article.path!}
          itemId={specialCard.article.id!}
          type="featureCard"
          theme={specialCard.theme}
          headingLevel={headingLevel}
        />
      </div>
      <div className={s.bannerCardsContainer}>
        {adObject && (
          <GoogleAdClient
            mobileAd={{
              ...adObject.mobile.middleAd,
              divProps: {
                style: {
                  width: `${adObject.mobile.middleAd.size[0]}px`,
                  height: `${adObject.mobile.middleAd.size[1]}px`,
                },
              },
            }}
            desktopAd={{
              ...adObject.desktop.middleAd,
              divProps: {
                style: {
                  width: `${adObject.desktop.middleAd.size[0]}px`,
                  height: `${adObject.desktop.middleAd.size[1]}px`,
                },
              },
            }}
            fallback={<BannerCardNavigationSlider bannerCards={bannerCards} />}
          />
        )}
      </div>
    </div>
  )
}
